import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Klage from './Klage.jsx'
import KlageIcon from '../../../images/Klage.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class KlageList extends Component {
    state = {
        klager: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getKlager = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/klage`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                klager: [...this.state.klager, ...data.klager].sort(this.klageComparer),
                isLoading: false,
                continuationToken: data.nextContinuationToken                
            })
        })
      }

      klageComparer = (a, b) => {
        if (a.klageFortDato == null || b.klageFortDato == null) return -1
        var firstDate = new Date(a.klageFortDato)
        var secondDate = new Date(b.klageFortDato)

        if (firstDate > secondDate) return -1
        if (firstDate < secondDate) return 1
        return 0
    }

      toggleKlager = () => {
        if (this.props.antall == 0) return

        if (this.state.klager.length == 0) {
            this.getKlager()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallKlager = this.state.continuationToken ? `${this.state.klager.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleKlager}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={KlageIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('klager')} ({antallKlager})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.klager.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.klager.map((k, index) => {return (<Klage key={k.klageId} klage={k} antall={this.props.antall} isLast={index==this.state.klager.length-1} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getKlager}>
                                <span>{t('hent.klage')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(KlageList)